var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Button"},[_c('a',{ref:"Btn",staticClass:"a",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}},[_c('ArrowSVG',{staticClass:"icon",style:({
      fill: _vm.color,
      opacity: _vm.opacity,
    })})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }